import { render, staticRenderFns } from "./SupplierType.vue?vue&type=template&id=4904fa76&scoped=true&"
import script from "./SupplierType.vue?vue&type=script&lang=js&"
export * from "./SupplierType.vue?vue&type=script&lang=js&"
import style0 from "./SupplierType.vue?vue&type=style&index=0&id=4904fa76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4904fa76",
  null
  
)

export default component.exports